"use client";
import React from "react";
import dedicatedSupport from '../../assets/dedicated/support.png'
import { Box, Stack, Typography } from "@mui/material";
import Grid from '@mui/material/Grid2';

const DedicatedSupportSection: React.FC = () => {
  return (
    <Box sx={{
      px: 1.5,
      display: "flex",
      flexDirection: "column",
      maxWidth: "1320px",
      width: "100%",
      margin: "0 auto",
    }}>
      <Grid container spacing={3} sx={{
              display: "flex",
              flexDirection: {md: "row", xs: "column"},
              alignItems: {xs: "flex-start", md: "center"},
              // gap: {xs: "32px", sm: "32px", md: "60px"},
              flexShrink: 0,
      }}>
        <Grid size={{xs: 12, md: 6}} sx={{
          order: 1,
          display: "flex",
          flexDirection: "column", 
          alignItems: "center",
          justifyContent: "center",
        }}>
          <Box 
            sx={{
              borderRadius: "12px",
              flexDirection: "column",
              alignSelf: "stretch",
              display: "flex",
              flexShrink: 0,
              backgroundImage: `url(${dedicatedSupport})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              minHeight: { md: "380px", xs: "224px" },
              height: "100%",
            }}
          />
        </Grid>
        <Grid size={{xs: 12, md: 6}} sx={{
          order: 2,
          display: "flex",
          flexDirection: "column", 
          alignItems: "center",
          justifyContent: "center",
        }}>
          <Box sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: {md: "32px", xs: "24px"},
            alignSelf: "stretch",
            flex: "1 0 0",

          }}>
        <Typography variant="subtitle8" sx={{
          textTransform: "uppercase",
          textAlign: "center",
          color: "darkPurple.500",
          }}>
          Dedicated <Box component="span" sx={{color: "lightPurple.500"}}>support</Box>
        </Typography>

        <Typography variant="body7" sx={{
          color: "gray.400",
          textTransform: "uppercase",
          alignSelf: "stretch",
        }}>
          Our expert team works closely with IT, Sales, Accounting, AML officers and more.
          Maintenance covers bug fixes, new partner integrations, and the creation of both custom
          and collaborative features. 
        </Typography>

        <Stack direction="row" alignItems="center" gap="6px" flexWrap="wrap">
          <Typography variant="body7" sx={{
            textTransform: "uppercase",
            color:"gray.400",
          }}>
            Available from
          </Typography>
          <Box
            sx={{
              backgroundColor: "lime.100",
              borderRadius: "12px",
              padding: "6px 14px",
              display: "flex",
              gap: "10px",
              alignItems: "center",
              justifyContent: "center",
            }}>
              <Typography variant="body8" sx={{
                color: "gray.400",
                textTransform: "uppercase",
              }}>
                8 AM
              </Typography>
          </Box>

          <Typography variant="body7" sx={{
            textTransform: "uppercase",
            color: "gray.400",
          }}>
            to
          </Typography>
          <Box
            sx={{
              backgroundColor: "lime.100",
              borderRadius: "12px",
              padding: "6px 14px",
              gap: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}>
              <Typography variant="body8" sx={{
                color: "gray.400",
                textTransform: "uppercase",
              }}>
                9 PM UTC
              </Typography>
          </Box>
          <Typography variant="body7" sx={{
            textTransform: "uppercase",
            color: "gray.400",
          }}>
            7 days a week
          </Typography>
        </Stack>
        </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DedicatedSupportSection;
